import React from "react";
import NavBar from "../components/NavBar";
import HomeBuyingGuidePage from "../components/HomeBuyingGuidePage";
import Footer from "../components/Footer";

const HomeBuyingGuide = () => {
    return(
        <div>
            <NavBar/>
            <HomeBuyingGuidePage/>
            <Footer/>
        </div>
    )
}

export default HomeBuyingGuide;